var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RememberMeActionTypes } from "./actions";
export function remember(state, action) {
    if (state === void 0) { state = { active: false }; }
    switch (action.type) {
        case RememberMeActionTypes.SET:
            return __assign(__assign({}, state), { active: action.active });
        case RememberMeActionTypes.SET_FAILED:
            return __assign(__assign({}, state), { failed: true });
        default:
            return state;
    }
}
